export const PDF_HORIZONTAL = 1;
export const PDF_VERTICAL = 2;
export const TICKET = 3;
export const PDF_NORMAL = 4;
